export default class admin {
  constructor(firstName, lastName, email, password) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.password = password;
  }
}



// WEBPACK FOOTER //
// ./src/models/admin.js